import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function useCategoriesBrands(websiteId) {
  const {categories} = useApolloQuery({
    query: gql`
      query categoriesBrands($websiteId: ID) {
        categories(websiteId: $websiteId) {
          items {
            _id
            name
            brand {
              _id
              name
              link
              menuImage {
                _id
                url: resizedURL(width: 1200, height: 240)
              }
              categoriesImage {
                _id
                url
              }
            }
          }
        }
      }
    `,
    variables: {websiteId}
  })

  return categories
}
